export default __webpack_public_path__ + "static/media/baobai.69ce7174.png";